import React, { Fragment } from 'react';
import {useParams} from "react-router-dom";
import ReportForm from './ReportForm';
import { Breadcrumbs } from '../../AbstractElements';

const ReportFormPage = () => {
  var { schedule_id, sequence_id } = useParams();
  
  return (
    <Fragment>
      <Breadcrumbs parent="Schedule" title="Report" />
      <ReportForm ScheduleID={schedule_id} SequenceID = {sequence_id} />
    </Fragment>
  );
};
export default ReportFormPage;